<template>
  <div class="ts-p-3">
    <div class="ts-overflow-y-scroll max-h">
      <div class="ts-flex ts-space-x-2">
        <button
          v-if="!isEdit"
          @click.prevent="onClickBrowse"
          class="ts-px-2 ts-py-1 ts-border ts-rounded ts-mb-2 hover:ts-bg-blue-600 ts-outline-none bg-primary ts-text-white"
        >
          {{ $t('purchaseOrder.fromFileImport') }}
        </button>
        <button
          v-if="!isEdit"
          @click.prevent="downloadTemplate"
          class="ts-px-2 ts-py-1 ts-border ts-rounded ts-mb-2 hover:ts-bg-gray-100 ts-outline-none"
        >
          {{ $t('purchaseOrder.downloadTemplate') }}
        </button>
      </div>
      <input type="file" ref="refFile" @change="fileChange" class="ts-hidden" />
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.barcode') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 15%"
            >
              {{ $t('purchaseOrder.name') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.uom') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.quantity') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.costThb') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.costUsd') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 8%"
            >
              {{ $t('purchaseOrder.discount') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.disType') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.amountThb') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 12%"
            >
              {{ $t('purchaseOrder.amount') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.maxReorder') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.alloworder') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-3 ts-text-center"
              style="width: 3%"
            >
              <a href="#" class="ts-text-white" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, index) in model.po_detail" :key="index">
            <td style="width: 10%">
              <input
                type="text"
                class="form-control"
                style="min-width: 90px"
                :value="
                  findProduct(d.product_id)
                    ? findProduct(d.product_id).barcode
                    : ''
                "
                readonly
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >
                {{ errors.first('po_detail.' + index + '.product_id') }}
              </div>
            </td>
            <td class="ts-p-2" style="width: 20%">
              <input
                type="text"
                :value="
                  findProduct(d.product_id)
                    ? findProduct(d.product_id).product_name_en
                    : ''
                "
                class="form-control"
                readonly
                style="min-width: 300px"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >
                {{ errors.first('po_detail.' + index + '.product_id') }}
              </div>
            </td>
            <td style="width: 10%">
              <a-select
                v-model="d.uom_id"
                class="ts-w-full"
                style="min-width: 70px"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }"
                @change="onUomChange(d)"
              >
                <a-select-option
                  v-for="(u, uIndex) in getUom(d.uom_cat_id)"
                  :key="uIndex"
                  :value="u.value"
                  >{{ u.label }}
                </a-select-option>
              </a-select>
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.uom_id')"
              >
                {{ errors.first('po_detail.' + index + '.uom_id') }}
              </div>
            </td>
            <td style="width: 5%">
              <input
                v-model.number="d.qty"
                type="number"
                ref="qty"
                @input="calculate(d)"
                class="form-control ts-text-center"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.qty')
                }"
                style="min-width: 70px"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.qty')"
              >
                {{ errors.first('po_detail.' + index + '.qty') }}
              </div>
            </td>
            <td style="width: 5%">
              <ts-currency-input
                v-model.number="d.cost_in_bath"
                :currency="default_currency_sign"
                class="form-control ts-text-right"
                style="min-width: 100px"
                :precision="default_precision"
                @input="onThbInput(d)"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.cost_in_bath')"
              >
                {{ errors.first('po_detail.' + index + '.cost_in_bath') }}
              </div>
            </td>
            <td style="width: 5%">
              <ts-currency-input
                v-model.number="d.cost"
                class="form-control ts-text-right"
                style="min-width: 100px"
                currency="$"
                :precision="default_precision"
                @input="value => onUsdInput(value, d)"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.cost')"
              >
                {{ errors.first('po_detail.' + index + '.cost') }}
              </div>
            </td>
            <td>
              <input
                ref="discountRate"
                v-model.number="d.discount_rate"
                @input="calculate(d)"
                type="number"
                class="form-control"
                :class="{
                  'is-invalid': errors.has(
                    'po_detail.' + index + '.discount_rate'
                  )
                }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.discount_rate')"
              >
                {{ errors.first('po_detail.' + index + '.discount_rate') }}
              </div>
            </td>
            <td style="width: 100px">
              <a-select
                v-model="d.discount_type"
                class="ts-w-full"
                style="min-width: 100px"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }"
                @change="calculate(d)"
              >
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="default_currency_sign">{{
                  default_currency_sign
                }}</a-select-option>
              </a-select>
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.discount_type')"
              >
                {{ errors.first('po_detail.' + index + '.discount_type') }}
              </div>
            </td>
            <td style="width: 10%">
              <ts-currency-input
                v-model.number="d.total_after_discount_in_bath"
                :currency="default_currency_sign"
                class="form-control ts-text-right"
                style="min-width: 100px"
                :precision="default_precision"
              />
              <div
                class="validate"
                v-if="
                  errors.has(
                    'po_detail.' + index + '.total_after_discount_in_bath'
                  )
                "
              >
                {{
                  errors.first(
                    'po_detail.' + index + '.total_after_discount_in_bath'
                  )
                }}
              </div>
            </td>
            <td style="width: 16%">
              <ts-currency-input
                v-model.number="d.total_after_discount"
                class="form-control ts-text-right"
                style="min-width: 100px"
                currency="$"
                :precision="default_precision"
              />
              <div
                class="validate"
                v-if="
                  errors.has('po_detail.' + index + '.total_after_discount')
                "
              >
                {{
                  errors.first('po_detail.' + index + '.total_after_discount')
                }}
              </div>
            </td>
            <td style="width: 3%">
              <input
                type="text"
                class="form-control ts-text-center"
                style="min-width: 90px"
                v-model="d.maximum_reorder_allow"
                readonly
              />
              <div
                class="validate"
                v-if="
                  errors.has('po_detail.' + index + '.maximum_reorder_allow')
                "
              >
                {{
                  errors.first('po_detail.' + index + '.maximum_reorder_allow')
                }}
              </div>
            </td>
            <td style="width: 1%" class="ts-text-center">
              <input type="checkbox" v-model="d.alloworder" />
            </td>
            <td style="width: 1%" class="ts-text-center">
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td class="ts-text-left ts-text-red-700">
              <p class="ts-font-extrabold">
                {{ $t('purchaseOrder.numberRow') + ': ' }}
                <span class="ts-font-extrabold">{{
                  model.po_detail.length
                }}</span>
              </p>
            </td>
            <td colspan="2" class="ts-text-right ts-text-red-700">
              <p class="ts-font-extrabold">{{ $t('purchaseOrder.total') }} :</p>
            </td>
            <td class="ts-text-center ts-text-red-700 ts-px-3">
              <p class="ts-font-extrabold" style="padding: 0 27px 0 13px">
                {{ $formatNumber(sumTotalQty) }}
              </p>
            </td>
            <td></td>
            <td class="ts-text-right ts-text-red-700 ts-whitespace-no-wrap">
              <p class="ts-font-extrabold" style="padding: 0 13px">
                {{ $currencyFormat(sumCost, 'USD', default_precision) }}
              </p>
            </td>
            <td colspan="2"></td>
            <td class="ts-text-right ts-text-red-700 ts-whitespace-no-wrap">
              <p class="ts-font-extrabold" style="padding: 0 13px">
                {{ $defaultCurrencyWithCode(sumTotalAfterDiscountInBath, 2) }}
              </p>
            </td>
            <td class="ts-text-right ts-text-red-700 ts-whitespace-no-wrap">
              <p class="ts-font-extrabold" style="padding: 0 13px">
                {{
                  $currencyFormat(
                    sumTotalAfterDiscount,
                    'USD',
                    default_precision
                  )
                }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- modal show pop-up to be able add product -->
      <a-modal
        v-if="show_modal_add_product"
        v-model="show_modal_add_product"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="900px"
        :title="$t('stockIn.product')"
      >
        <ProductList v-model="model" @calculate="calculate" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import * as XLSX from 'xlsx/xlsx.mjs'
import { Errors } from 'form-backend-validation'
import { mapGetters, mapState } from 'vuex'
import ProductList from './product-list.vue'
import { round, sumBy, trim } from 'lodash'

export default {
  name: 'purchaseOrderItem',
  components: {
    ProductList
  },
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      model: {},
      newRow: {
        product_id: null,
        uom_id: null,
        uom_cat_id: null,
        qty: 1,
        maximum_reorder_allow: 0,
        alloworder: false,
        cost: 0,
        cost_in_bath: 0,
        total_after_discount_in_bath: 0,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: 0
      }
    }
  },
  computed: {
    ...mapState('purchaseOrder/order', ['edit_data']),
    ...mapGetters('purchaseOrder/order', [
      'getProduct',
      'getUom',
      'findProduct',
      'getCostPrice',
      'getProductByBarcode'
    ]),
    sumTotalAfterDiscount() {
      return round(
        sumBy(this.model.po_detail, 'total_after_discount'),
        this.default_precision
      )
    },
    sumTotalAfterDiscountInBath() {
      return round(
        sumBy(this.model.po_detail, 'total_after_discount_in_bath'),
        this.default_precision
      )
    },
    sumTotalQty() {
      return sumBy(this.model.po_detail, 'qty')
    },
    sumCost() {
      return round(sumBy(this.model.po_detail, 'cost'), this.default_precision)
    },
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    isEdit() {
      return Object.keys(this.edit_data).length
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    addNewRow() {
      this.show_modal_add_product = true
    },
    addItem(product) {
      this.model.po_detail.push({
        product_id: product.product_id,
        uom_id: product.uom_id,
        uom_cat_id: product.uom_cat_id,
        qty: product.qty ? product.qty : 1,
        maximum_reorder_allow: product.maximum_reorder_allow,
        alloworder: false,
        cost: round(
          product.cost * this.model.fx_rate_thb,
          this.default_precision
        ), // at machinary world cost is in thb, cost * with exchange rate becuase exchange from usd -> thb
        discount_rate: product.discount_rate,
        discount_type: product.discount_type,
        cost_in_bath: round(product.cost, this.default_precision),
        total_after_discount_in_bath: round(
          product.cost * (product.qty ? product.qty : 1),
          this.default_precision
        ),
        total_after_discount: round(
          product.cost *
            this.model.fx_rate_thb *
            (product.qty ? product.qty : 1),
          this.default_precision
        )
      })
    },
    removeItem(index) {
      this.model.po_detail.splice(index, 1)
    },
    productChange(options, row) {
      row.uom_id = options.data.props.uom_id
      row.uom_cat_id = options.data.props.uom_cat_id
    },
    onUomChange(row) {
      row.cost = this.getCostPrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      this.calculate(row)
    },
    onThbInput(row) {
      this.calculate(row)
    },
    onUsdInput(value, row) {
      const usdToBath = round(
        value * this.model.fx_rate_thb,
        this.default_precision
      )
      row.cost_in_bath = usdToBath
      row.cost = usdToBath
      this.calculate(row)
    },
    calculate(row) {
      // cost is in bath currency
      if (row.discount_type == '%') {
        row.cost = round(row.cost, this.default_precision)
        let discount = round(row.cost * row.qty * (row.discount_rate / 100), 2)
        let discount_bath = round(
          row.cost_in_bath * row.qty * (row.discount_rate / 100),
          2
        )
        row.total_after_discount = round(
          row.cost * this.model.fx_rate_thb * row.qty - discount, // cost * with fx_rate_thb because fx_rate_thb is usd -> thb
          this.default_precision
        )
        row.total_after_discount_in_bath = round(
          row.cost_in_bath * row.qty - discount_bath,
          this.default_precision
        )
      } else {
        row.total_after_discount = round(
          (row.cost_in_bath * row.qty - row.discount_rate) /
            this.model.fx_rate_thb,
          this.default_precision
        )
        row.total_after_discount_in_bath = round(
          row.cost_in_bath * row.qty - row.discount_rate,
          this.default_precision
        )
      }
    },
    onClickBrowse() {
      this.$refs.refFile.click()
    },
    fileChange(e) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const workbookData = this.parseWorksheetData(worksheet)
          const worksheetData = workbookData.slice(1)
          if (worksheetData.length) {
            worksheetData.forEach(item => {
              const product = this.getProductByBarcode({
                chosenProduct: this.model.po_detail,
                search: item[0].toString().replace('-', '')
              })
              if (product.length === 0) {
                this.$toasted.error(
                  `The product not found with barcode : ${item[0]}`
                )
              } else if (product.length >= 1) {
                this.addItem({
                  ...product[0],
                  ...{
                    discount_rate: item[4] ? item[4] : 0,
                    discount_type: item[5] ? item[5] : '%',
                    cost: item[3] ? item[3] : 0,
                    qty: item[2] ? item[2] : null
                  }
                })
              }
            })
          }
        }
      }
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          const cell = worksheet[cellAddress]

          if (cell) {
            // const cellValue = cell ? cell.v : undefined
            row[colNum] = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push(row)
        }
      }
      return jsonData
    },
    downloadTemplate() {
      this.$store
        .dispatch('purchaseOrder/order/downloadTemplate')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.py {
  padding: 0.45rem 5px;
}

.max-h {
  min-height: 30vh;
  max-height: 50vh;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
}

table tbody tr td {
  padding: 4px 5px;
}

table {
  position: relative;
  border-collapse: collapse;
}
</style>
